import { Api } from 'apiClient/Api';

/**
 * Aufrufe für Endpunkte, die der generierte Client noch nicht kennt.
 *
 * **Nicht `api.instance` verwenden.** Der `Authorization`-Header wird von `HttpClient.request()`
 * über den `securityWorker` gesetzt, nicht als Interceptor auf der Axios-Instanz. Ein direkter
 * `api.instance.get(...)` geht deshalb ohne Anmeldung raus und läuft in einen 401 — sichtbar wird
 * das nur als „nichts konfiguriert", weil der Fehler in einem catch landet und die Oberfläche
 * ihre Vorgabewerte zeigt.
 *
 * `secure: true` und `format: 'json'` entsprechen genau dem, was der Generator für jeden
 * geschützten Endpunkt erzeugt. Sobald `npm run generate-api` gegen einen Server mit diesen
 * Endpunkten lief, können die Aufrufe hier durch die generierten Methoden ersetzt werden.
 */
export const settingsApi = (api: Api<unknown>) => ({
    get: <T>(path: string, query?: Record<string, unknown>) =>
        api.request<T, unknown>({ path, method: 'GET', query, secure: true, format: 'json' }),

    put: <T>(path: string, body: unknown) =>
        api.request<T, unknown>({ path, method: 'PUT', body, secure: true, format: 'json' }),

    post: <T>(path: string, query?: Record<string, unknown>, body?: unknown) =>
        api.request<T, unknown>({ path, method: 'POST', query, body, secure: true, format: 'json' }),

    patch: <T>(path: string, body: unknown) =>
        api.request<T, unknown>({ path, method: 'PATCH', body, secure: true, format: 'json' }),

    delete: <T>(path: string) =>
        api.request<T, unknown>({ path, method: 'DELETE', secure: true, format: 'json' }),
});
